import React from 'react';
import I18n from 'i18n-js';
import CollapsingList from '@reverbdotcom/commons/src/components/collapsing_list';
import { core_apimessages_ShopTaxPolicy } from '../../../schemas/rql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

interface Props {
  taxPolicies: core_apimessages_ShopTaxPolicy[];
}

const TAX_POLICIES_HELP_LINK = 'https://help.reverb.com/hc/en-us/articles/360019132973-How-State-Sales-Tax-Applies-to-Reverb-Orders';

function TaxPolicy({ policy }: { policy: core_apimessages_ShopTaxPolicy }) {
  return (
    <>
      <td>
        {policy.policyType === 'MARKETPLACE_REGION' ? `${policy.displayLocation}*` : policy.displayLocation}
      </td>
      <td>
        {
          policy.displayRate
            ? `${policy.displayRate}%`
            : I18n.t('discovery.shopTaxPolicies.calculatedAtCheckout')
        }
      </td>
    </>
  );
}

function NoPolicy() {
  return (
    <p data-no-policies>
      {I18n.t('discovery.shopTaxPolicies.noPolicies')}
    </p>
  );
}

export default function ShopTaxPoliciesInternal({ taxPolicies }: Props) {
  if (taxPolicies.length === 0) {
    return <NoPolicy />;
  }

  return (
    <>
      <table className="basic-table">
        <thead>
          <tr>
            <td>
              {I18n.t('discovery.shopTaxPolicies.region')}
            </td>
            <td>
              {I18n.t('discovery.shopTaxPolicies.rate')}
            </td>
          </tr>
        </thead>
        <CollapsingList renderAsTableBody>
          {taxPolicies.map((p) => (
            <TaxPolicy policy={p} key={p.displayLocation} />
          ))}
        </CollapsingList>
      </table>
      <div className="size-80 opacity-80">
        {I18n.t('discovery.shopTaxPolicies.marketplaceRegion')}
        <CoreLink
          to={TAX_POLICIES_HELP_LINK}
          className="ml-space"
        >
          {I18n.t('discovery.shopTaxPolicies.learnMore')}
        </CoreLink>
      </div>
    </>
  );
}
